import React, { ReactNode } from 'react';
import { Heading, Text, Stack, Paragraph } from '@mos-cat/ds';
import { pxToRem } from '@mos-cat/ds-theme';

type Props = {
  heading: ReactNode;
  children?: ReactNode;
};

// typograf-enable
export default function OutageBlock({ heading, children }: Props) {
  return (
    <Stack p="sp-16" backgroundColor="gray-10" borderRadius={pxToRem(12)}>
      <Heading as={Text} level={4}>
        {heading}
      </Heading>
      <Paragraph>{children}</Paragraph>
    </Stack>
  );
}
